import { render } from "./FormSwitch.vue?vue&type=template&id=56f347ac"
import script from "./FormSwitch.vue?vue&type=script&lang=js"
export * from "./FormSwitch.vue?vue&type=script&lang=js"

import "./FormSwitch.vue?vue&type=style&index=0&id=56f347ac&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__